// Constants for presence subscriptions and discounts
export const TYPE_AMOUNT = 'amount'
export const TYPE_PERCENTAGE = 'percentage'

export const SOURCE_ROLLOVER = 'rollover'
export const SOURCE_FIRST_MONTH = 'first_month'
export const SOURCE_GENERAL = 'general'

export const STATUS_ACTIVE = 'active'
export const STATUS_INACTIVE = 'inactive'
export const STATUS_PENDING = 'pending'
export const STATUS_ON_HOLD = 'on_hold'

// Types for better type safety
export type DiscountType = typeof TYPE_AMOUNT | typeof TYPE_PERCENTAGE
export type DiscountStatus =
    | typeof STATUS_ACTIVE
    | typeof STATUS_INACTIVE
    | typeof STATUS_PENDING
    | typeof STATUS_ON_HOLD
export type DiscountSource =
    | typeof SOURCE_ROLLOVER
    | typeof SOURCE_FIRST_MONTH
    | typeof SOURCE_GENERAL

export interface ProvidersPresenceDiscount {
    service_provider_presence_discount_id: number
    service_provider_presence_subscription_id: number
    amount: number
    type: DiscountType
    status: DiscountStatus
    months_count?: number
    source: DiscountSource
    expiry_date?: string
    start_date?: string
    end_date?: string
}

export interface RolloverDiscountRequest {
    months_count: number
    discount_type: DiscountType
    discount_amount: number
    expiry_date?: string
}

export interface ProvidersPresenceSubscription {
    service_provider_presence_subscription_id: number
    service_provider_id: number
    subscription_id: number
    service_id: number
    service_name: string
    status:
        | typeof STATUS_ACTIVE
        | typeof STATUS_INACTIVE
        | typeof STATUS_PENDING
        | typeof STATUS_ON_HOLD
    start_date: string
    subscription_override_amount: number | null
    presence_discounts?: ProvidersPresenceDiscount[]
    presence_promos?: ProvidersPresencePromo[]
}

export interface ProviderPresenceSubscriptionData {
    subscription: ProvidersPresenceSubscription | null
    allowPresenceSubscription: boolean
    serviceId?: number
    amount?: number
    overrideAmount?: number | null
    error?: string
    isUpdating?: boolean
}

export interface PresenceSubscriptionHistoryItem {
    id: number
    service_name: string
    subscription_override_amount: number | null
    status: string
    start_date: string | null
    end_date: string | null
    discounts: Array<{
        service_provider_presence_discount_id: number
        service_provider_presence_subscription_id: number
        type: string
        amount: number
        start_date: string
        end_date: string
        status: string
        source?: string
        months_count?: number
        expiry_date?: string
    }>
}

// Promo types
export const PROMO_SOURCE_CAMPAIGN = 'campaign'
export const PROMO_SOURCE_OFFICE = 'office'
export const PROMO_TYPE_PROMO = 'promo'

export type PromoSource = typeof PROMO_SOURCE_CAMPAIGN | typeof PROMO_SOURCE_OFFICE
export type PromoType = typeof PROMO_TYPE_PROMO

export interface ProvidersPresencePromo {
    service_provider_presence_promo_id: number
    service_provider_presence_subscription_id: number
    type: PromoType | null
    amount: number
    source: PromoSource | null
    utm_details: string | null
    extra_info: string | null
    status: DiscountStatus
    start_date: string | null
    expiry_date: string | null
    created: string
    modified: string | null
    user_id: number | null
    user?: {
        user_id: number
        username: string
        first_name: string | null
        last_name: string | null
    } | null
}

export interface ProviderPromo {
    service_provider_promo_id: number
    service_provider_id: number
    promo_id: number | null
    user_id: number | null
    type: PromoType | null
    amount: number
    source: PromoSource | null
    utm_details: string | null
    extra_info: string | null
    status: DiscountStatus
    start_date: string | null
    end_date: string | null
    created: string
    modified: string | null
}
